import React from "react";
import {observable} from 'mobx';
import {observer, inject} from "mobx-react";
import {Route, Link, Switch} from "react-router-dom";
import classnames from "classnames";
import MobileNavigation from "@components/Navigation/MobileNavigation";

import BasketOrderView from "@components/Order/BasketOrderView";

//import ComplaintEdit from "@components/MyPages/ComplaintEdit";
import IcomRouter from "@components/Navigation/IcomRouter";
import IcomHashRoute from "@components/Navigation/IcomHashRoute";
import IcomHashLink from "@components/Navigation/IcomHashLink";
import IcomHashSwitch from "@components/Navigation/IcomHashSwitch";
import PurchaseOrderView from "@components/Order/PurchaseOrderView";
import PurchaseOrderCheckout from "@components/Order/PurchaseOrderCheckout";
import PurchaseOrderThankYou from "@components/Order/PurchaseOrderThankYou";
import PurchaseOrderAdd from "@components/Order/PurchaseOrderAdd";
import PurchaseOrderSettingsView from "@components/Order/PurchaseOrderSettingsView";


import SearchViewModal from "@components/Search/SearchViewModal";
import {ToolbarDropdown, ToolbarSection} from "@components/Toolbar/ToolbarDropdown";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import CategoryNavigationSticky from "@components/Navigation/CategoryNavigationSticky";
import SortOptions from "@components/Navigation/SortOptions";
import FilterToolBar from "@components/Toolbar/FilterToolBar";
import SortToolbar from "@components/Toolbar/SortToolbar";
import DesktopNavigation from "@components/Navigation/DesktopNavigation";
import SizeChart from "@components/SizeChart/SizeChart";
import Logotype from "@components/Toolbar/Logotype";


import LoginForm from "@components/Login/FormikLogin"

// todo: Fix reactivation on f5..
const ToggleButton = (
    observer(({classes, name, children, showToggle, mainRouter, navigation
                  // ,toolbarRouter
    }) => {

        const tabPathName = `${name}`;
        let baseUrl = "";
        // if (match.url === "/") {
        //     baseUrl = "";
        // } else {
        //     baseUrl = match.url;
        // }

        const path = `${baseUrl}/${tabPathName}`;

        //const goBackOrSideWays = toolbarRouter && toolbarRouter.location && toolbarRouter.location.pathname && mainRouter.location.hash && mainRouter.location.hash.substring(1) === toolbarRouter.location.pathname;
        const hasLocationHash = (mainRouter.location && mainRouter.location.hash && mainRouter.location.hash.length > 2 && mainRouter.location.hash.charAt(1) === '/')|| false;
        
        // if the toolbar was opened by the client, they are in sync, but if an hash appears in the first request, they will not be. Then close tab has to navigate forward
        const serverRender = typeof window === 'undefined';
        
        //const nextToolbarLevel = navigation.toolbarLevel + 1;
        const toolbarLevelState =  !isNaN(parseInt(mainRouter.location.state)) ? parseInt(mainRouter.location.state) : 0 ;
        const nextToolbarLevel = toolbarLevelState + 1;
        const newHistoryObject = mainRouter
            ? {
                pathname: mainRouter.location.pathname,
                search: mainRouter.location.search,
                hash: path,
                state: hasLocationHash ? toolbarLevelState  : nextToolbarLevel  //"hashLocation",
            } : null;


        //console.log("hasLocationHash", hasLocationHash, newHistoryObject );

        // if (toolbarRouter) {
        //     console.debug("toggleButton", name, path, mainRouter.location.hash, toolbarRouter.location, goBackOrSideWays);
        // }

        //console.log("render", path);

        return (
            <IcomHashSwitch>
                
                
                <IcomHashRoute path={path}>
                    <a
                        href={"/"}
                        onClick={(event) => {
                            event.preventDefault();
                            navigation.closeToolbar();
                            //
                            // if(hasLocationHash) {
                            //     mainRouter.goBack();
                            // }
                            // else
                            // {
                            //     mainRouter.replace({pathname: mainRouter.location.pathname, search: mainRouter.location.search, hash: ""})
                            // }
                        }}
                         className={classnames("toolbar-toggle",
                            classes,
                            {
                                active: true
                            })}>{children}
                        <FontAwesomeIcon icon={["fas", "times"]} className={"close"} size="xs"/>

                    </a>
                </IcomHashRoute>
                <IcomHashRoute path="*">
                    <React.Fragment>
                        {showToggle
                            // ? !serverRender
                               && <IcomHashLink
                                    key={path}    
                                    to={newHistoryObject}
                                    replace={hasLocationHash}
                                    
                                                                        
                                        // onClick={() => {
                                        //     if (newHistoryObject) {
                                        //         if (goBackOrSideWays)
                                        //             mainRouter.replace(newHistoryObject)
                                        //         else
                                        //             mainRouter.push(newHistoryObject)
                                        //     }
                                        // }}
                                        className={classnames("toolbar-toggle",
                                            classes,
                                            {
                                                active: false
                                            })}>{children}
                                    <FontAwesomeIcon icon={["fas", "times"]} className={"close"} size="xs"/>
                                </IcomHashLink>
                                // : <a
                                //     href={"#"}
                                //     key={path}
                                //     className={classnames("toolbar-toggle atag",
                                //     classes,
                                //     {
                                //         active: false
                                //     })}>{children}
                                //     <FontAwesomeIcon icon={["fas", "times"]} className={"close"} size="xs"/>
                                // </a>
                            // : null
                        }

                    </React.Fragment>
                </IcomHashRoute>
            </IcomHashSwitch>

        );

    })
);


@inject("store")
@observer
class ToolbarMenuBeriksson extends React.Component {
    @observable  showForgotPassword = false;

    constructor(props) {
        super(props);
        this.accountStore = this.props.store.account;
        this.closeTabs = this.closeTabs.bind(this);
        this.toggleForgotPassword = this.toggleForgotPassword.bind(this);
        this.setRef = this.setRef.bind(this);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }


    setRef(node) {
        this.Ref = node;
    }


    toggleForgotPassword() {
        this.showForgotPassword = !this.showForgotPassword;
    }

    get isDropDownOpen() {
        return true;
    }


    closeTabs(forceReplaceUrl = false) {
        this.props.store.navigation.closeToolbar(forceReplaceUrl);
    }

    render() {
        const navigation = this.props.store.navigation;
        const orderStore = this.props.store.order;
        const activeOrder = orderStore.activeOrder;
        const isMobile = navigation.isMobile;
        const orderArticleCount = activeOrder ? activeOrder.OrderArticleCount : 0;
        const hasProducts = Object.keys(this.props.store.navigation.ProductsView).length > 0;
        const orderTotalFormatted = activeOrder ? activeOrder.OrderTotalFormatted : "";

        const hash = navigation.mainRouter && navigation.mainRouter.location && navigation.mainRouter.location.hash && navigation.mainRouter.location.hash.length > 1 && navigation.mainRouter.location.hash.substring(1);
        const hashLocation = navigation.toolbarRouter.location && {...navigation.toolbarRouter.location, pathname: hash, test:1};

        return (
            // <Route
            //     //location={navigation.toolbarRouter.location}
            //     location={hashLocation}
            //
            //     render={({match, location, history}) =>

            <div className="toolbar container-fluid" ref={this.setRef}>

                <Logotype/>

                <div className="desktop-navigation">
                    <DesktopNavigation
                        className="site-menu"
                        isMegamenu={true}
                        tree={navigation.mainTree}/>
                </div>

                <div className={"toolbar-search " + (navigation.isProductModalOpen ? "product-modal-open" : "")}>
                    {hasProducts &&
                        <div className="toolbar-filter-search-mobile">
                            <div className="row">
                                <FilterToolBar/>
                                <SortToolbar/>
                            </div>
                        </div>}
                </div>

                <div className={"tools "}>
                    <ToggleButton
                        classes={""}
                        name={"search"}
                        // match={match}
                        // location={location}
                        mainRouter={navigation.mainRouter}
                        //toolbarRouter={navigation.toolbarRouter}
                        navigation={navigation}
                        showToggle={true}
                    >
                        <span className={"align-helper"}></span>
                        <FontAwesomeIcon icon={["fas", "search"]} className={"toggle"} size="sm"/>
                    </ToggleButton>


                    <ToggleButton
                        classes={"mobile-menu-account"}
                        name={"MyPages"}
                        // match={match}
                        // location={location}
                        showToggle={true}
                        mainRouter={navigation.mainRouter}
                        navigation={navigation}
                        //toolbarRouter={navigation.toolbarRouter}
                    >
                        <FontAwesomeIcon icon={["fas", "user"]} className={"toggle"} size="sm"/>
                    </ToggleButton>


                    {false && !navigation.CustomerRoleIsReadOnly &&
                        <ToggleButton
                            classes={""}
                            name={activeOrder ? "order" : "order/add"}
                            // match={match}
                            // location={location}
                            history={history}
                            showToggle={true}
                        >
                            <i style={{fontSize: "1.25em"}}>
                                <span className="material-icons shopping_basket"/>

                                {(activeOrder) &&
                                    <span className="count"><span className="count-text">{orderArticleCount}</span></span>}

                                {(!activeOrder) &&
                                    <span className="count"><span className="count-text">+</span></span>}

                                {(activeOrder && orderTotalFormatted) &&
                                    <span className="total">
                                                {orderTotalFormatted}
                                            </span>}
                            </i>
                        </ToggleButton>
                    }


                    {!navigation.CustomerRoleIsReadOnly &&
                        <ToggleButton
                            classes={"basket"}
                            name={activeOrder
                                ? "order"
                                : navigation.isD2C
                                    ? "order"
                                    : "order/add"}
                            // match={match}
                            // location={location}
                            mainRouter={navigation.mainRouter}
                            //toolbarRouter={navigation.toolbarRouter}
                            showToggle={true}
                            navigation={navigation}
                            style={{lineHeight: "56px"}}
                        >
                            <span className={"align-helper"}></span>
                            <FontAwesomeIcon icon={["fas", "shopping-cart"]} className={"toggle"} size="sm"/>

                            {(activeOrder && orderArticleCount > 0) &&
                                <span className="count"><span className="count-text">{orderArticleCount}</span></span>}

                            {(activeOrder && orderArticleCount > 0 && orderTotalFormatted) &&
                                <span className="total">
                                            {orderTotalFormatted}
                                        </span>}


                        </ToggleButton>
                    }
                    <ToggleButton
                        classes={"mobile-menu-toggle"}
                        name={"Site"}
                        // match={match}
                        // location={location}
                        showToggle={true}
                        mainRouter={navigation.mainRouter}
                        navigation={navigation}
                        //toolbarRouter={navigation.toolbarRouter}
                    >
                        <span className={"align-helper"}></span>
                        <FontAwesomeIcon icon={["fas", "bars"]} className={"toggle"} size="sm"/>
                    </ToggleButton>
                </div>

                <IcomHashSwitch>


                    <IcomHashRoute path={`/Site`} render={() =>
                        <ToolbarDropdown
                            closeOnOverlayClick={false}

                            left={false} hideHeader={false} isNavigation={true} header={this.props.store.navigation.dictionary.Menu}
                        >
                            <ToolbarSection className="scroll-content">
                                <IcomRouter history={this.props.store.navigation.mstToolbarHistory}>
                                    <MobileNavigation
                                        key="nav"
                                        closeTabs={this.closeTabs}
                                        //root="site"

                                        //addEvents={this.addEvents}

                                        removeEvents={this.removeEvents}
                                        tree={this.props.store.navigation.mainTree}
                                        addNodes={this.props.store.navigation.marketSettings.MarketNavigationTree.Children}


                                    />
                                </IcomRouter>
                            </ToolbarSection>
                        </ToolbarDropdown>
                    }/>

                    <IcomHashRoute path={`/sizechart`} render={() =>
                        <ToolbarDropdown left={false} hideHeader={false} isNavigation={true} header={this.props.store.navigation.dictionary.OpenSizeChart}
                        >
                            <ToolbarSection>
                                <SizeChart/>
                            </ToolbarSection>
                        </ToolbarDropdown>
                    }/>

                    <IcomHashRoute path={`/filter`} render={() =>
                        <ToolbarDropdown left={false}

                                         hideHeader={true}
                                         header={this.props.store.navigation.dictionary.Filter}
                                         forceReplaceUrl={true}
                                         className={"center"}
                        >
                            <ToolbarSection className="filter-view left-filter-bar scroll-content">
                                <CategoryNavigationSticky
                                    showCategories={false}
                                />
                            </ToolbarSection>
                            <div className="show-products">
                                <div className="filter-icon" onClick={() => {
                                    this.closeTabs(true);
                                }}>{this.props.store.navigation.dictionary.ShowProducts} {navigation.totalResults ? " (" + navigation.totalResults + ")" : null}</div>
                            </div>
                        </ToolbarDropdown>

                    }/>

                    <IcomHashRoute path={`/search`} render={() =>
                        <ToolbarDropdown
                            closeOnOverlayClick={navigation.isMobile}
                            left={false} hideHeader={false} header={this.props.store.navigation.dictionary.Search || "Search"}
                        >
                            <ToolbarSection>
                                <SearchViewModal hideClose={false}/>
                            </ToolbarSection>
                        </ToolbarDropdown>
                    }/>


                    <IcomHashRoute path={`/sort`} render={() =>
                        <ToolbarDropdown
                            left={false}
                            hideHeader={true}
                            header={this.props.store.navigation.dictionary.Sort}
                            forceReplaceUrl={true}
                            className={"center"}
                        >
                            <ToolbarSection className="sort-view"
                            >
                                <SortOptions/>
                            </ToolbarSection>
                            <div className="show-products">
                                <div className="filter-icon" onClick={() => {
                                    this.closeTabs(true);
                                }}>{this.props.store.navigation.dictionary.ShowProducts}</div>
                            </div>
                        </ToolbarDropdown>

                    }/>

                    {false && this.accountStore.isLoggedIn ?

                        <Route path={`/account/:component`} render={(props) =>
                            <ToolbarDropdown
                                closeOnOverlayClick={false}>
                                <ToolbarSection className="scroll-content">
                                    <nav className="slideable-menu mt-4">
                                        <ul className="menu">
                                            <li>
                                                <ul className="slideable-submenu ">
                                                    <li className="back-btn"><Link to={`/account`}>Mina sidor</Link></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </nav>
                                    <div className="mt-4">
                                        <MyPages {...props} />
                                    </div>
                                </ToolbarSection>
                            </ToolbarDropdown>
                        }/>
                        : ""}

                    <IcomHashRoute path={`/MyPages`} render={() =>
                        <ToolbarDropdown
                            closeOnOverlayClick={navigation.isMobile}
                            left={false} hideHeader={false} isNavigation={true} header={this.props.store.navigation.dictionary.MyPages || "Mina sidor"}
                        >
                            <ToolbarSection className="scroll-content">

                                {/*{this.props.store.account.isLoggedIn ?*/}
                                <MobileNavigation
                                    key="account"
                                    closeTabs={this.closeTabs}
                                    //addEvents={this.ad    dEvents}
                                    removeEvents={this.removeEvents}
                                    tree={this.props.store.navigation.myPagesTree}/>
                                {/*: <LoginForm/>*/}
                                {/*}*/}
                            </ToolbarSection>

                        </ToolbarDropdown>
                    }/>


                    <IcomHashRoute path={`/basket`} render={(
                        // {match}
                    ) =>

                        <PurchaseOrderView
                            // match={match} 
                            hideHeader={false}
                            closeOnOverlayClick={navigation.isMobile}
                        />

                    }/>


                    <IcomHashRoute path={`/order/thankyou/:orderNumber`} render={(
                        { match }
                    ) =>
                        <PurchaseOrderThankYou
                            orderNumber={match.params.orderNumber}
                            hideHeader={false}
                            closeOnOverlayClick={navigation.isMobile}
                        />
                    } />

                    <IcomHashRoute path={`/order/thankyou`} render={(
                        // {match}
                    ) =>
                        <PurchaseOrderThankYou
                            // match={match}
                            hideHeader={false}
                            closeOnOverlayClick={navigation.isMobile}
                        />
                    }/>

                    <IcomHashRoute path={`/order/add`} render={() =>
                        <PurchaseOrderAdd

                            hideHeader={false}
                            closeOnOverlayClick={navigation.isMobile}
                        />
                    }/>

                    <IcomHashRoute path={`/order/settings`} render={(
                        // {match}
                    ) =>
                        <PurchaseOrderSettingsView
                            // match={match}
                            hideHeader={false}
                            closeOnOverlayClick={navigation.isMobile}
                            header={this.props.store.navigation.dictionary.Settings || "Inställningar"}
                        />
                    }/>

                    <IcomHashRoute path={`/order/checkout`} render={(
                        // {match}
                    ) =>
                        activeOrder ? <PurchaseOrderCheckout
                            // match={match}
                            hideHeader={false}
                            closeOnOverlayClick={navigation.isMobile}
                            header={this.props.store.navigation.dictionary.Checkout || "Utcheckning"}
                        /> : null

                    }/>

                    <IcomHashRoute path={`/order`} render={(
                        // {match}
                    ) =>
                        navigation.isD2C
                            ? <BasketOrderView
                                // match={match}
                                hideHeader={false}
                                closeOnOverlayClick={navigation.isMobile}
                            />
                            : <PurchaseOrderView
                                // match={match}
                                hideHeader={false}
                                closeOnOverlayClick={navigation.isMobile}/>
                    }/>

                    {/* <Route path={`/product/:sku`} render={({ match }) =>
                                    <EditProductView match={match} />
                                } />*/}


                    {/*<Route path={`/complaints`} render={({ match }) =>*/}
                    {/*    <ComplaintEdit match={match}*/}
                    {/*        hideHeader={true}*/}
                    {/*        closeOnOverlayClick={navigation.isMobile} />*/}
                    {/*} />*/}


                </IcomHashSwitch>


            </div>

//                }/>


        );
    }
}

export default ToolbarMenuBeriksson;

